import React, { useState, useEffect } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faGrin } from '@fortawesome/free-solid-svg-icons';
import SVG from 'react-inlinesvg';
import { Container, Row, Col, Card, Accordion } from 'react-bootstrap';
import Layout from '../components/Layout';
import Head from '../components/head';
import Section from '../components/Section';
import PageTitle from '../components/PageTitle';
import SwooptyBg from '../components/SwooptyBg';
import ReviewStars, { animateStars } from '../components/ReviewStars';
import StaticReviewStars from '../components/ReviewStars/staticStars';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import reviews from '../data/reviews/reviews.json';
// import { pink500 } from '../ui/colors';
import { FranchiseeProvider } from '../context/Franchisee';
import ReviewLinks from '../components/ReviewLinks';

interface ReviewsPageProps {
  /* add reviews page props here */
}

const Reviews: React.FC<ReviewsPageProps> = () => {
  const [firstReview] = reviews.defaultReviews;

  // cycle stars animation
  useEffect(animateStars);

  // control toggle icon on header
  const [activeEventKey, setActiveEventKey] = useState('-1');
  function toggleEventKey(eventKey: string): void {
    if (activeEventKey === eventKey) {
      setActiveEventKey('-1');
    } else {
      setActiveEventKey(eventKey);
    }
  }

  return (
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='reviews'
          title='Reviews - Two Maids Professional Cleaning Services'
          description='Reviews from Two Maids cleaning services customers.'
        />
        <OpenGraphTitle title='Reviews - Two Maids Professional Cleaning Services' />
        <OpenGraphDescription>
          Reviews from Two Maids cleaning services customers.
        </OpenGraphDescription>
        <div className='top-background-dots'></div>

        <Section className='first-review-section'>
          {/* <PageTitle className='sr-only mb-5'>Reviews</PageTitle> */}
          <PageTitle className='mb-2'>WHAT OUR CLIENTS SAY</PageTitle>
            <Col xs={9} md={7} lg={5} className='mb-5 mb-lg-0 first-review'>
              {firstReview?.imageUrl && (
                <div className='round-circle-container'>
                  <img
                    src={firstReview?.imageUrl}
                    className='rounded-circle'
                    width='720'
                    height='688'
                    alt={firstReview.name}
                    />
                    <div className='first-review-content'>
                      <div className='review__content'>
                        {firstReview.content}
                      </div>
                      <div className='review__name'>
                        {firstReview.name}
                      </div>
                      <div className='review__location'>
                        {firstReview.location}
                      </div>
                  </div>
                </div>
              )}
            </Col>
        </Section>
        <Section padding='bottom'>
          <div
            id='reviews-accordion'
            className='reviews__accordion accordion review-stars__trigger'
          >
            <Accordion>
              {reviews.defaultReviews.map((review, index) =>
                index >= 1 ? (
                  <Card className='reviews__review' key={review.name}>
                    <Card.Header>
                      <Row className='flex-md-nowrap justify-content-between justify-content-md-center'>
                        <Col className='align-self-center'>
                          <small className='review__name font-weight-bold'>
                            {review.name}
                          </small>
                          <StaticReviewStars />
                          <div className='mt-1'>
                            {review.content}
                          </div>
                        </Col>
                      </Row>
                    </Card.Header>
                  </Card>
                ) : null
              )}
            </Accordion>
          </div>
        </Section>
        <Section padding='top' className='pb-5 pb-md-0'>
          <ReviewLinks />
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
};

export default Reviews;
